jQuery(function ($) {
  const Scripts = {
    varInit() {
      this.header = $("header");
      this.document = $(document);
      this.observer = null;
    },

    headerScroll() {
      const $header = $(".header");
      const scrollThreshold = 20;

      let ticking = false;
      let isFixed = null;

      const updateHeader = () => {
        const shouldBeFixed = window.scrollY > scrollThreshold;
        if (shouldBeFixed !== isFixed) {
          isFixed = shouldBeFixed;
          $header.toggleClass("_fixed", isFixed);
        }

        ticking = false;
      };

      const onScroll = () => {
        if (ticking) {
          return;
        }

        ticking = true;
        requestAnimationFrame(updateHeader);
      };

      updateHeader();

      window.addEventListener("scroll", onScroll, {
        passive: true,
      });
    },

    navInit() {
      const $body = $("body"),
        $nav = $(".js-nav"),
        $navButton = $(".js-nav-button"),
        $navFirstLink = $nav.find(".menu a"),
        $search = $(".js-search-form"),
        $searchButton = $(".js-search-button"),
        $searchField = $search.find('input[type="search"]');

      const nav = {
        $trigger: $navButton,
        $panel: $nav,
        $focusTarget: $navFirstLink,
      };

      const search = {
        $trigger: $searchButton,
        $panel: $search,
        $focusTarget: $searchField,
      };

      const closePanel = ({ $trigger, $panel }, returnFocus = false) => {
        $trigger.removeClass("_active").attr("aria-expanded", "false");
        $panel.removeClass("_active").prop("hidden", true);
        if (returnFocus) {
          $trigger[0]?.focus();
        }
      };

      const openPanel = ({ $trigger, $panel, $focusTarget }, panelToClose) => {
        if (panelToClose) {
          closePanel(panelToClose);
        }
        $trigger.addClass("_active").attr("aria-expanded", "true");
        $panel.addClass("_active").prop("hidden", false);
        $body.addClass("_locked");

        if ($focusTarget?.length) {
          setTimeout(() => {
            $focusTarget.filter(":visible")[0]?.focus();
          }, 100);
        }
      };

      const togglePanel = (panel, panelToClose) => {
        const isOpen = panel.$trigger.hasClass("_active");

        if (isOpen) {
          closePanel(panel);
          $body.removeClass("_locked");
        } else {
          openPanel(panel, panelToClose);
        }
      };

      $navButton.on("click", function () {
        togglePanel(nav, search);
      });

      $searchButton.on("click", function () {
        togglePanel(search, nav);
      });

      $(document).on("keydown", function (event) {
        if (event.key !== "Escape") {
          return;
        }

        if (search.$trigger.hasClass("_active")) {
          closePanel(search, true);
          $body.removeClass("_locked");
          return;
        }

        if (nav.$trigger.hasClass("_active")) {
          closePanel(nav, true);
          $body.removeClass("_locked");
        }
      });
    },

    searchClearInit() {
      const $searchWrap = $(".js-search-input");

      $searchWrap.each((index, element) => {
        const $wrap = $(element);
        const $searchField = $wrap.find('input[type="search"]');
        const $searchClear = $wrap.find(".search__input-clear");
        $searchClear.addClass($searchField.val().length ? "_active" : "");
        $searchField.on("input", function (e) {
          if ($searchField.val().length) {
            $searchClear.addClass("_active");
          } else {
            $searchClear.removeClass("_active");
          }
        });

        $searchClear.on("click", function () {
          $searchField.val("").trigger("input").trigger("focus");
        });
      });
    },

    observeItems(items = ".js-observe") {
      if (!("IntersectionObserver" in window)) {
        $(items).addClass("_in-view");
        return;
      }

      if (!this.observer) {
        this.observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) {
                return;
              }

              entry.target.classList.add("_in-view");
              observer.unobserve(entry.target);
            });
          },
          {
            root: null,
            rootMargin: "0px 0px -5% 0px",
            threshold: 0,
          },
        );
      }

      document.querySelectorAll(items).forEach((element) => {
        if (
          element.classList.contains("_in-view") ||
          element.dataset.observerInitialized === "true"
        ) {
          return;
        }

        element.dataset.observerInitialized = "true";
        this.observer.observe(element);
      });
    },

    itemsObserverInit() {
      const init = () => requestAnimationFrame(() => this.observeItems());

      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init, { once: true });
        return;
      }

      init();
    },

    copyButtonInit() {
      $(".js-copy-button").on("click", function (e) {
        const $button = $(this),
          $container = $button.parents(".js-copy"),
          $valueElement = $container.find(".js-copy-value"),
          value = $valueElement.is("input, textarea, select")
            ? ($valueElement.val() || "").trim()
            : ($valueElement.text() || "").trim();

        navigator.clipboard.writeText(value);

        $(
          '<div class="js-copy-message" style="display:none">' +
            $button.data("message").trim() +
            "</div>",
        )
          .insertAfter($button)
          .fadeIn(500, () => {
            setTimeout(() => {
              $container
                .find(".js-copy-message")
                .fadeOut(500, function remove() {
                  $(this).remove();
                });
            }, 800);
          });
      });
    },

    slidersInit() {
      const $importantSlider = $(".important__slider"),
        $contactSlider = $(".contact-media__slider");

      function updateProgress(swiper) {
        const progress = (swiper.activeIndex + 1) / swiper.slides.length;

        $(".important-progress span").css("transform", `scaleX(${progress})`);
      }

      if ($importantSlider.length) {
        const $nextButtons = $(".important-next"),
          $prevButtons = $(".important-prev"),
          $paginations = $(".important-pagination");
        $importantSlider.each(function (index, slider) {
          new Swiper(slider, {
            slidesPerView: 1,
            centeredSlides: false,
            spaceBetween: 20,
            a11y: true,
            loop: false,
            speed: 1000,
            autoHeight: false,
            navigation: {
              nextEl: $nextButtons[index],
              prevEl: $prevButtons[index],
            },
            keyboard: {
              enabled: true,
              onlyInViewport: true,
            },
            pagination: {
              el: $paginations[index],
              type: "fraction",
              formatFractionCurrent(number) {
                return String(number).padStart(2, "0");
              },
              formatFractionTotal(number) {
                return String(number).padStart(2, "0");
              },
            },
            on: {
              init(swiper) {
                updateProgress(swiper);
              },

              slideChange(swiper) {
                updateProgress(swiper);
              },
            },
          });
        });
      }

      if ($contactSlider.length) {
        const slider = new Swiper($contactSlider[0], {
          slidesPerView: 1,
          centeredSlides: false,
          spaceBetween: 20,
          a11y: true,
          loop: false,
          speed: 1000,
          fadeEffect: {
            crossFade: true,
          },
          navigation: {
            nextEl: ".contact-next",
            prevEl: ".contact-prev",
          },
          keyboard: {
            enabled: true,
            onlyInViewport: false,
          },
          pagination: {
            el: ".contact-pagination",
            type: "fraction",
            formatFractionCurrent(number) {
              return String(number).padStart(2, "0");
            },
            formatFractionTotal(number) {
              return String(number).padStart(2, "0");
            },
          },
        });
      }
    },

    tabsInit() {
      if (!$(".js-tabs-buttons").length) {
        return;
      }

      $(".js-tabs-buttons button").on("click", function (e) {
        e.preventDefault();

        handleTabButton($(this));
      });

      $(".js-tabs-buttons button").on("keydown", function (e) {
        const $buttons = $(this).closest(".js-tabs-buttons").find("button");

        const currentIndex = $buttons.index(this);

        let nextIndex;

        if (e.key === "ArrowRight") {
          nextIndex = (currentIndex + 1) % $buttons.length;
        } else if (e.key === "ArrowLeft") {
          nextIndex = (currentIndex - 1 + $buttons.length) % $buttons.length;
        } else if (e.key === "Home") {
          nextIndex = 0;
        } else if (e.key === "End") {
          nextIndex = $buttons.length - 1;
        } else {
          return;
        }

        e.preventDefault();

        const $nextButton = $buttons.eq(nextIndex);

        handleTabButton($nextButton);

        $nextButton[0].focus({
          preventScroll: true,
        });
      });

      function handleTabButton(button) {
        const index = button.index(),
          wrap = button.parents(".js-tabs-wrap"),
          tabs = wrap.find(".js-tabs-item"),
          target = wrap.find(`.js-tabs-item:nth-child(${index + 1})`),
          buttons = button.closest(".js-tabs-buttons").find("button");

        buttons.removeClass("_active").attr({
          "aria-selected": "false",
          tabindex: "-1",
        });

        button.addClass("_active").attr({
          "aria-selected": "true",
          tabindex: "0",
        });

        tabs.removeClass("_active");
        target.addClass("_active");
      }
    },

    dropdownsInit() {
      if (!$(".js-dropdown").length) {
        return;
      }

      function closeDropdowns() {
        $(".js-dropdown-button")
          .removeClass("_active")
          .attr("aria-expanded", "false");

        $(".js-dropdown-list").removeClass("_active").prop("hidden", true);
      }

      $(".js-dropdown").each(function () {
        const $dropdown = $(this),
          $button = $dropdown.find(".js-dropdown-button"),
          $list = $dropdown.find(".js-dropdown-list"),
          $radios = $dropdown.find('input[type="radio"]');
        let isKeyboardInteraction = false;
        let isPointerInteractionInside = false;
        $radios.attr("tabindex", "-1");

        function openDropdown(shouldFocusRadio = false) {
          closeDropdowns();

          $button.addClass("_active").attr("aria-expanded", "true");
          $list.addClass("_active").prop("hidden", false);

          if (!shouldFocusRadio) {
            return;
          }

          requestAnimationFrame(() => {
            const $checked = $radios.filter(":checked");
            const $target = $checked.length ? $checked : $radios.first();

            $target.trigger("focus");
          });
        }

        $button.on("click", function (e) {
          e.stopPropagation();

          const isActive = $button.hasClass("_active");

          if (isActive) {
            closeDropdowns();
            return;
          }

          openDropdown();
        });

        $dropdown.on("pointerdown", function () {
          isPointerInteractionInside = true;
          isKeyboardInteraction = false;
        });

        $(document).on("pointerup pointercancel", function () {
          isPointerInteractionInside = false;
        });

        /** Open dropdown on keyboard focus
         */
        // $button.on("focus", function () {
        //   if (!this.matches(":focus-visible")) {
        //     return;
        //   }

        //   openDropdown();
        // });

        /** Enter dropdown options
         */
        $button.on("keydown", function (e) {
          if (e.key !== "ArrowDown") {
            return;
          }

          e.preventDefault();
          e.stopPropagation();

          isKeyboardInteraction = true;

          openDropdown(true);
        });

        $radios.on("pointerdown", function () {
          isKeyboardInteraction = false;
        });

        $dropdown.on("focusout", function () {
          requestAnimationFrame(() => {
            if (isPointerInteractionInside) {
              return;
            }

            const activeElement = document.activeElement;

            if (activeElement && $.contains($dropdown[0], activeElement)) {
              return;
            }

            closeDropdowns();
          });
        });

        $list.on("click", function (e) {
          e.stopPropagation();
        });

        /** Keyboard navigation inside dropdown
         */
        $radios.on("keydown", function (e) {
          const isNext = e.key === "ArrowDown" || e.key === "ArrowRight";

          const isPrevious = e.key === "ArrowUp" || e.key === "ArrowLeft";

          const isSelect = e.key === "Enter" || e.key === " ";

          if (!isNext && !isPrevious && !isSelect && e.key !== "Escape") {
            return;
          }

          e.preventDefault();
          e.stopPropagation();

          isKeyboardInteraction = true;

          if (e.key === "Escape") {
            closeDropdowns();
            $button.trigger("focus");

            return;
          }

          if (isSelect) {
            $(this).prop("checked", true).trigger("change");

            return;
          }

          const currentIndex = $radios.index(this);
          const direction = isNext ? 1 : -1;

          const nextIndex =
            (currentIndex + direction + $radios.length) % $radios.length;

          $radios.eq(nextIndex).trigger("focus");
        });

        $radios.on("change", function () {
          Scripts.updateDropdownState($dropdown);
          closeDropdowns();
          if (isKeyboardInteraction) {
            $button.trigger("focus");
          }

          isKeyboardInteraction = false;
        });

        Scripts.updateDropdownState($dropdown);
      });

      $(document).on("click", function () {
        closeDropdowns();
      });
    },

    updateDropdownState($dropdown, shouldClose = true) {
      const $button = $dropdown.find(".js-dropdown-button"),
        $list = $dropdown.find(".js-dropdown-list"),
        $checked = $dropdown.find('input[type="radio"]:checked'),
        placeholder = $button.data("placeholder-text");

      if ($checked.length && $checked.val()) {
        const text = $checked.closest("label").find("span").text().trim();

        $button.text(text);
      } else {
        $button.text(placeholder);
      }

      if (shouldClose) {
        $button.removeClass("_active").attr("aria-expanded", "false");
        $list.removeClass("_active").prop("hidden", true);
      }
    },

    radioNavigationInit() {
      const $groups = $(".js-radio-navigation");

      if (!$groups.length) {
        return;
      }

      $groups.each(function () {
        const $group = $(this);
        const $radios = $group.find('input[type="radio"]');

        if (!$radios.length) {
          return;
        }

        $radios.attr("tabindex", "-1");
        $radios.first().attr("tabindex", "0");

        $radios.on("keydown", function (e) {
          const isNext = e.key === "ArrowDown" || e.key === "ArrowRight";

          const isPrevious = e.key === "ArrowUp" || e.key === "ArrowLeft";

          const isSelect = e.key === "Enter" || e.key === " ";

          if (!isNext && !isPrevious && !isSelect) {
            return;
          }

          e.preventDefault();

          if (isSelect) {
            $(this).prop("checked", true).trigger("change");

            return;
          }

          const currentIndex = $radios.index(this);
          const direction = isNext ? 1 : -1;
          const nextIndex =
            (currentIndex + direction + $radios.length) % $radios.length;

          $radios.attr("tabindex", "-1");

          $radios.eq(nextIndex).attr("tabindex", "0").trigger("focus");
        });
      });
    },

    splitTextToWords() {
      if (!$(".js-split-words").length) {
        return;
      }

      $(".js-split-words").each(function (index, element) {
        const $element = $(this),
          text = $element.text().trim(),
          words = text.split(/\s+/),
          $fragment = $(document.createDocumentFragment());

        words.forEach((word, index) => {
          const $wrapper = $("<span>", {
            class: "word-wrapper",
          });

          const $inner = $("<span>", {
            class: "word",
            text: word,
          });

          $wrapper.append($inner);
          $fragment.append($wrapper);

          if (index !== words.length - 1) {
            $fragment.append(" ");
          }
        });

        $element.empty().append($fragment);
      });
    },

    datepickerInit() {
      if (!$("input[type='date']").length || !$.fn.flatpickr) {
        return;
      }

      const args = {
        dateFormat: "d.m.Y",
        mode: "range",
        showMonths: 2,
        monthSelectorType: "static",
      };

      if (document.documentElement.lang.startsWith("uk")) {
        args.locale = "uk";
      }

      $("input[type='date']").flatpickr({
        ...args,
        onValueUpdate(selectedDates, dateStr, instance) {
          instance.input.value = dateStr.replace(" to ", " / ");
        },
        onOpen(selectedDates, dateStr, instance) {
          $(instance.input).closest(".dropdown__input").addClass("_active");
        },
        onClose(selectedDates, dateStr, instance) {
          $(instance.input).closest(".dropdown__input").removeClass("_active");
        },
      });

      $(document).on("filters:clear", ".js-filter-section", function () {
        $(this)
          .find(".flatpickr-input")
          .each(function () {
            $(this).get(0)._flatpickr?.clear();
          });
      });

      $(document).on("filters:set", ".js-filter-section", function () {
        $(this)
          .find(".flatpickr-input")
          .each(function () {
            const input = $(this).get(0);
            const initialValue = input.value.trim();

            if (!initialValue) {
              return;
            }
            const dates = initialValue
              .split("/")
              .map((date) => date.trim())
              .filter(Boolean);

            $(this).get(0)._flatpickr?.setDate(dates, false, "d.m.Y");
          });
      });
    },

    postsFilterInit() {
      const $sections = $(".js-filter-section");

      if (!$sections.length || typeof PostsFilterSection === "undefined") {
        return;
      }

      $(document).on("dropdown:update", ".js-filter-section", function () {
        $(this)
          .find(".js-dropdown")
          .each(function () {
            Scripts.updateDropdownState($(this));
          });
      });

      const filterSections = [];

      $sections.each(function () {
        const filterSection = new PostsFilterSection($(this));

        if (filterSection.isValid) {
          filterSections.push(filterSection);
        }
      });

      window.addEventListener("popstate", function () {
        filterSections.forEach((filterSection) => {
          filterSection.syncFromUrl();
        });
      });
    },

    paginatedSectionInit() {
      $(document).on(
        "click",
        ".js-paginated-section .pagination__button[data-page]",
        function () {
          const $button = $(this);
          const page = $button.data("page");
          const $section = $button.closest(".js-paginated-section");
          const $grid = $section.find(".js-paginated-section-list");
          const $paginationButtons = $section.find(
            ".pagination__button[data-page]",
          );

          if ($grid.attr("aria-busy") === "true") {
            return;
          }

          $.ajax({
            url: ajaxData.ajaxUrl,
            type: "POST",
            data: {
              action: "load_paginated_section",
              nonce: ajaxData.nonce,
              post_id: $section.attr("data-current-post-id"),
              source_field: $section.attr("data-source-field"),
              template: $section.attr("data-template"),
              per_page: $section.attr("data-per-page"),
              page,
            },

            beforeSend() {
              $grid.addClass("_loading");
              $grid.attr("aria-busy", "true");

              $paginationButtons.prop("disabled", true);
            },

            success(response) {
              if (!response.success) {
                return;
              }
              const sectionTop = $section.offset().top - 20;
              $grid.html(response.data.html);
              $section.find(".pagination").html(response.data.pagination);
              $("html, body").animate(
                {
                  scrollTop: sectionTop,
                },
                300,
              );
            },

            error(xhr, textStatus, errorThrown) {
              const message =
                xhr.responseJSON?.data?.message ||
                errorThrown ||
                "Failed to load paginated section.";

              console.error(
                `Paginated section request failed (${xhr.status}): ${message}`,
              );
            },

            complete() {
              $grid.removeClass("_loading");
              $grid.attr("aria-busy", "false");
              $section
                .find(".pagination__button[data-page]")
                .prop("disabled", false);
            },
          });
        },
      );
    },

    formHelpers() {
      /** Отримуємо значення поля форми
       */
      function getFieldValue($form, name) {
        const $checked = $form.find(`[name="${name}"]:checked`);

        if ($checked.length) {
          return $checked.val();
        }

        const $field = $form.find(`[name="${name}"]`);

        if (!$field.length) {
          return "";
        }

        return $field.val();
      }

      function parseCondition(rawCondition) {
        try {
          return JSON.parse(rawCondition);
        } catch (error) {
          console.warn("Invalid condition JSON:", rawCondition);
          return null;
        }
      }

      /** Перевіряємо, чи значення полів форми відповідають тим, які в умовах
       */
      function conditionMatches($form, condition) {
        return Object.entries(condition).every(([fieldName, expectedValue]) => {
          const currentValue = getFieldValue($form, fieldName);
          const expectedValues = Array.isArray(expectedValue)
            ? expectedValue
            : [expectedValue];

          return expectedValues.includes(currentValue);
        });
      }

      /** Перевіряємо всі умови на формі і змінюємо видимість відповідних рядків
       */

      function updateConditionalRows($form) {
        $form.find("[data-condition]").each(function () {
          const $row = $(this);
          const condition = parseCondition($row.attr("data-condition"));

          if (!condition) {
            return;
          }

          const show = conditionMatches($form, condition);

          $row.prop("hidden", !show);
          $row.find(":input").prop("disabled", !show);
        });
      }

      function updateRequiredLabels($form) {
        $form.find("label[data-require-if]").each(function () {
          const $label = $(this);
          const condition = parseCondition($label.attr("data-require-if"));

          if (!condition) {
            return;
          }

          const required = conditionMatches($form, condition);

          $label.toggleClass("_required", required);
        });
      }

      function updateFormState($form) {
        updateConditionalRows($form);
        updateRequiredLabels($form);
      }

      function customizeCf7Counters($form) {
        $form.find(".wpcf7-character-count").each(function () {
          const $count = $(this);
          const max = $count.attr("data-maximum-value");
          const limitTemplate = ajaxData?.i18n?.textareaCounterLabel || "";
          const limitLabel = limitTemplate
            ? limitTemplate.replace("%s", max)
            : "";

          if ($count.closest(".form-counter").length) {
            return;
          }

          $count.wrap('<span class="form__counter"></span>');
          $count.after(
            $("<span>", {
              class: "form__counter-text",
              text: limitLabel,
            }),
          );
        });
      }

      $(".wpcf7-form").each(function () {
        const $form = $(this);

        updateFormState($form);
        customizeCf7Counters($form);

        $form.on("change input", ":input", function () {
          updateFormState($form);
        });
      });

      $(".codedropz-upload-wrapper").each(function (index) {
        const $wrapper = $(this);
        const noteId = `upload-note-${index}`;
        const uploadNoteText = ajaxData?.i18n?.uploadTotalLimit || "";

        if ($wrapper.find(".form__upload-note").length) {
          return;
        }

        $wrapper.find(".codedropz-upload-handler").append(`
          <p class="form__upload-note" id="${noteId}">
            ${uploadNoteText}
          </p>
        `);
        $wrapper.find('input[type="file"]').attr("aria-describedby", noteId);
      });

      document.addEventListener("wpcf7mailsent", function (event) {
        const $form = $(event.target).closest(".js-form");
        const $message = $form.find(".js-success-message");
        const formTop = $form.offset().top - 120;

        $form.addClass("_success");
        $message.prop("hidden", false);

        $("html, body").animate(
          {
            scrollTop: formTop,
          },
          300,
        );
      });

      document.querySelectorAll(".wpcf7-form").forEach((form) => {
        const uploadField = form.querySelector(".wpcf7-drag-n-drop-file");

        if (!uploadField) {
          return;
        }

        const inputBlock = uploadField.closest(".form__input");

        if (!inputBlock) {
          return;
        }

        const hasUploadError = () => {
          return Boolean(
            inputBlock.querySelector(".dnd-upload-status .has-error"),
          );
        };

        const removeValidationMessage = () => {
          if (hasUploadError()) {
            return;
          }

          inputBlock.querySelector(".js-upload-not-valid-tip")?.remove();
        };

        form.addEventListener(
          "submit",
          (event) => {
            if (!hasUploadError()) {
              return;
            }

            event.preventDefault();
            event.stopImmediatePropagation();

            if (inputBlock.querySelector(".js-upload-not-valid-tip")) {
              return;
            }

            const language = document.documentElement.lang;

            const errorMessage = language.startsWith("uk")
              ? "Видаліть файл із помилкою перед відправленням форми."
              : "Remove the invalid file before submitting the form.";

            const errorElement = document.createElement("span");

            errorElement.className =
              "wpcf7-not-valid-tip js-upload-not-valid-tip";

            errorElement.setAttribute("role", "alert");
            errorElement.textContent = errorMessage;

            inputBlock.append(errorElement);
          },
          true,
        );

        const observer = new MutationObserver(removeValidationMessage);

        observer.observe(inputBlock, {
          childList: true,
          subtree: true,
        });
      });
    },

    showVideoOnce() {
      function seekToEnd(video) {
        video.currentTime = Math.max(video.duration - 0.2, 0);

        video.addEventListener(
          "seeked",
          function () {
            video.pause();
            video.classList.remove("_is-seeking");
          },
          { once: true },
        );
      }

      $(".leadership__photo").each(function () {
        const $wrapper = $(this);
        const $video = $wrapper.find("video");

        if (!$video.length) {
          return;
        }
        const video = $video[0];
        const videoId = $wrapper.attr("data-video-id");
        const videoVersion = $wrapper.attr("data-video-version");
        const pageId = $wrapper.data("page-id");

        if (!pageId || !videoId || !videoVersion) {
          return;
        }
        const key = `video-${pageId}-${videoId}-${videoVersion}`;

        if (localStorage.getItem(key)) {
          if (video.readyState >= 1) {
            seekToEnd(video);
          } else {
            video.addEventListener(
              "loadedmetadata",
              function () {
                seekToEnd(video);
              },
              { once: true },
            );
          }
          return;
        }

        $video.removeClass("_is-seeking");
        video.play();

        $video.one("ended", function () {
          localStorage.setItem(key, "1");
        });
      });
    },

    scrollController() {
      function scrollToSectionEnd($section, offset = 0) {
        if (!$section.length) {
          return;
        }

        const sectionBottom = $section.offset().top + $section.outerHeight();
        const targetScroll = sectionBottom - $(window).height() + offset;

        $("html, body").animate(
          {
            scrollTop: targetScroll,
          },
          500,
        );
      }

      $(".js-scroll-to-end").on("click", function (e) {
        e.preventDefault();
        const $section = $(this).parents("section");
        scrollToSectionEnd($section, 80);
      });
    },

    spollers() {
      $("details").each(function () {
        const faqItem = $(this);
        const question = faqItem.find("summary");
        const answer = question.next();
        const group = faqItem.closest(".accordion");

        if (faqItem.prop("open")) {
          answer.show();
        } else {
          answer.hide();
        }

        question.on("click", function (e) {
          e.preventDefault();

          const isOpen = faqItem.prop("open");

          if (isOpen) {
            answer.slideUp(360, function () {
              faqItem.prop("open", false);
            });
          } else {
            faqItem.prop("open", true);
            answer.slideDown(360);
            group
              .find("details")
              .not(faqItem)
              .each(function () {
                const otherItem = $(this);
                const otherAnswer = otherItem.find("summary").next();

                if (otherItem.prop("open")) {
                  otherAnswer.slideUp(360, function () {
                    otherItem.prop("open", false);
                  });
                }
              });
          }
        });
      });
    },

    init() {
      Scripts.varInit();
      Scripts.headerScroll();
      Scripts.navInit();
      Scripts.itemsObserverInit();
      Scripts.splitTextToWords();
      Scripts.copyButtonInit();
      Scripts.slidersInit();
      Scripts.tabsInit();
      Scripts.dropdownsInit();
      Scripts.radioNavigationInit();
      Scripts.datepickerInit();
      Scripts.postsFilterInit();
      Scripts.paginatedSectionInit();

      Scripts.formHelpers();
      Scripts.showVideoOnce();
      Scripts.scrollController();
      Scripts.searchClearInit();

      if ($("details").length) {
        Scripts.spollers();
      }
    },
  };

  $(document).ready(function () {
    Scripts.init();
  });
});
